import React from 'react'
import Rencana_KedatanganService from '../Service/rencana_kedatanganService'
import FormInput from './formInput'
import FormInputNew from './formInputNew'
import ModalHapus from './modalHapus'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import ModalHapusList from './modalHapusList'
import { config } from '../Config/config'
import ModalLoading from './modalLoading'
import ModalBerhasil from './modalBerhasil'
import ModalPenuh from './modalPenuh'
import ModalTidakAdaDokter from './modalTidakAdaDokter'


export default class index extends React.Component {
    rencanaModel = {
        _id: "",
        appoinment_id: "",
        doctor_office_schedule_id: "",
        doctor_office_treatment_id: "",
        doctor_treatment_id: "",
        doctor_id: "",
        appointment_date: "",
        tanggal_datang: "",
        tanggal_datang2: "",
        // tanggal : tanggal_datang.substring(0,10),
        nama_pasien: "",
        hubungan: "",
        nama_dokter: "",
        spesialisasi: "",
        Tyear: 0,
        Myear: 0,
        image: "",
        medical_facility: "",
        medical_facility_id: "",
        treatment: "",
        year: "",
        date: "",
        month: "",
        parent_biodata_id: localStorage.getItem(config.biodata_id),
    }

    constructor() {
        super()
        this.state = {
            tanggal: "",
            tanggal_datang2: "",
            jam: "",
            cek: [],
            List: [],
            ListById: [],
            ListTreatment: [],
            Model: this.rencanaModel,
            Model2: this.rencanaModel,
            errors: {},
            showModal: false,
            showModalJanjiNew: false,
            showModalDel: false,
            showModalLoad: false,
            showModalBerhasil: false,
            showModalPenuh: false,
            showModalDokter : false,
            TotalPage: 0,
            count: 0,
            filter: {
                search: "",
                order: "",
                page: '1',
                pageSize: '5',
                urut: 'tanggal_kedatangan',
                appoinment_done: [],
                biodata_id: localStorage.getItem(config.biodata_id)
            },

            ListDelete: [],
            day: "",
            slot : 0
            // ListNameDelete: []
        }
    }


    loadList = async () => {
        const responById = await Rencana_KedatanganService.getAppoinment()

        this.setState({
            ListById: responById.result[0].appoinment_done
        })
        console.log(this.state.ListById)

        this.setState({
            filter: {
                ...this.state.filter,
                ['appoinment_done']: this.state.ListById
            }
        })
        console.log(this.state.filter.appoinment_done)

        const respon = await Rencana_KedatanganService.getAllFilter(this.state.filter)
        const responCount = await Rencana_KedatanganService.countData(this.state.filter)


        if (respon.success) {
            let count = 0
            if (responCount.result != undefined) {
                count = responCount.result.count
            }
            this.setState({
                List: respon.result,
                // ListById : responById.result,
                TotalPage: Math.ceil(count / this.state.filter.pageSize)
            })

        }


    }

    componentDidMount() {
        this.loadList()
        console.log(localStorage.getItem(config.biodata_id))
    }

    // //untuk filter
    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    // //untuk merubah nama dan description di form input
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })

    }

    // //untuk button submit
    saveHandler = async () => {
        if (this.handleValidation()) {
            if (this.state.Mode == "UBAH JANJI") {

                this.setState({
                    showModalLoad: true
                    // Model2 : this.rencanaModel
                })

                const respon = await Rencana_KedatanganService.getById(this.state.Model._id)
                var d = new Date(this.state.Model.tanggal_datang)
                var d1 = d.getDay().toString()
                this.setState({
                    Model2: respon.result,
                    tanggal: this.state.Model.tanggal_datang.substring(0, 10),
                    jam: parseInt(this.state.Model.tanggal_datang.substring(11,13)),
                    tanggal_datang2: this.state.Model.tanggal_datang.concat('Z')
                })
                // console.log(d1)
                console.log(this.state.jam)
                console.log(this.state.tanggal_datang2)
                console.log(this.state.tanggal)

                var responDay = await Rencana_KedatanganService.cekDay({ "day": d1, "faskes": this.state.Model.medical_facility[0], "nama_dokter": this.state.Model.nama_dokter[0], "jam" : this.state.jam })

                if (responDay.result.length != 0) {
                    this.setState({
                        slot : parseInt(responDay.result[0].slot)
                    })
                    const responCek = await Rencana_KedatanganService.cekRencana(this.state.tanggal)
                    this.setState({
                        cek: responCek.result
                    })
                    // console.log(this.state.cek)


                    if (this.state.cek.length < this.state.slot) {
                        const responEditRes = await Rencana_KedatanganService.EditDataRes({"_id":this.state.Model._id ,"doctor_office_schedule_id":this.state.Model.doctor_office_schedule_id, "doctor_office_treatment_id":this.state.Model.doctor_office_treatment_id ,"tanggal_datang":this.state.tanggal_datang2})
                        const responAddRes = await Rencana_KedatanganService.addDataRes({"_id":this.state.Model._id ,"doctor_office_schedule_id":this.state.Model.doctor_office_schedule_id, "doctor_office_treatment_id":this.state.Model.doctor_office_treatment_id ,"tanggal_datang":this.state.tanggal_datang2})
                        console.log(responAddRes.result)
                        console.log(responEditRes.result)

                        if (responEditRes.success) {
                            
                            this.setState({
                                Model: responEditRes.result,
                                showModal: false,
                                showModalLoad: false,
                                showModalPenuh: false,
                                showModalBerhasil: true
                            },()=>{console.log(this.state.Model)})
                            this.loadList()
                            // alert("Success Update Data")
                        }
                    } else {
                        this.setState({
                            showModal: false,
                            showModalLoad: false,
                            showModalPenuh: true
                        })
                    }

                }
                else{
                    this.setState({
                        showModalLoad: false,
                        showModalDokter: true
                    })
                    // alert("Tidak ada jadwal dokter yang bersangkutan pada tanggal tersebut")
                }


            }

        } else {
            alert("Form has errors.")
        }
    }




    // //untuk modal
    editHandler = async (id) => {
        console.log(id)
        const respon = await Rencana_KedatanganService.getById(id)

        console.log(respon)

        if (respon.success) {
            this.setState({
                Model: respon.result,
                Model2: respon.result
            })
        }

        const responTreatment = await Rencana_KedatanganService.getByFaskesId(this.state.Model.medical_facility_id)
        if (responTreatment.success) {
            this.setState({
                ListTreatment: responTreatment.result
            })
        }
        console.log(this.state.ListTreatment)

        this.setState({
            Mode: "UBAH JANJI",
            showModal: true,
            showModalDokter:false,
            Model: respon.result,
            Model2: respon.result,
            tanggal: this.state.Model.tanggal_datang.substring(0, 10),
            jam: parseInt(this.state.Model.tanggal_datang.substring(11, 13)),
            tanggal_datang2: this.state.Model.tanggal_datang.concat('Z')
        },()=>{console.log(this.state.tanggal_datang2)})
    }

    createHandler = () => {
        this.setState({
            Mode: "TAMBAH JANJI",
            showModalJanjiNew: true,
            Model: this.rencanaModel
        })
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            showModal: false,
            showModalDel: false,
            showModalDel2: false,
            showModalJanjiNew: false,
            showModalLoad: false,
            showModalBerhasil: false,
            showModalPenuh: false,
            showModalDokter: false
        })
    }

    // //button checkbox delete
    deleteCheck = async (id) => {
        const { ListDelete } = this.state
        const respon = await Rencana_KedatanganService.getById(id)


        if (respon.success) {
            var data = {
                _id: respon.result._id,
                appointment_id: respon.result.appointment_id
            }


            let index = ListDelete.findIndex(x => x._id === data._id && x.appointment_id === data.appointment_id)

            if (index == -1) {
                ListDelete.push(data)
            } else {
                ListDelete.splice(index, 1)
            }

            console.log(ListDelete)

            this.setState({
                Model: respon.result
            })
        }


    }

    // //button awal List delete
    deleteHandlerr = () => {
        this.setState({
            showModalDel2: true
        })
    }

    // //button modal List yakin delete
    deleteHandlerr2 = async () => {
        let tmplist = this.state.ListDelete
        console.log(tmplist)

        for (let i = 0; i < tmplist.length; i++) {
            const respon = await Rencana_KedatanganService.DeleteDataCancel(tmplist[i])
            const responPostCancel = await Rencana_KedatanganService.PostDataCancel(tmplist[i])
            if (respon.success) {
                this.loadList()
            }
        }
        this.setState({
            showModalDel2: false
        })

    }

    // //button awal delete
    deleteHandler = async (id) => {
        const respon = await Rencana_KedatanganService.getById(id)
        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }

    }

    // //button modal yakin delete
    deleteHandler2 = async () => {
        let tmpID = this.state.Model
        console.log(tmpID)
        const respon = await Rencana_KedatanganService.DeleteDataCancel(tmpID)
        const responAddCancel = await Rencana_KedatanganService.PostDataCancel(tmpID)
        // console.log(this.state.Model._id)

        if (respon.success) {
            alert("succes Delete Data")
            this.loadList()
            this.setState({
                showModalDel: false
            })
        }
    }


    // // untuk validasi
    handleValidation() {
        let fields = this.state.Model
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["tanggal_datang"]) {
            formIsValid = false;
            errors["tanggal_datang"] = "Waktu kedatangan harus diisi";
        }

        if (!fields["treatment"]) {
            formIsValid = false;
            errors["tanggal_lahir"] = "Tindakan Medis harus diisi";
        }


        this.setState({ errors: errors });
        return formIsValid;
    }

    // //untuk membuat sort
    sortHandler = () => {
        let sort = ''
        sort = this.state.filter.order == '' ? '1' : '-1'
        sort = this.state.filter.order == '-1' ? '1' : '-1'

        this.setState({
            filter: {
                ...this.state.filter,
                ['order']: sort
            }
        }, () => this.loadList())
    }

    // //untuk mengambil total halaman
    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pageSize"]: size
            }
        }, () => this.loadList())
    }

    // //untuk membuat nomor halaman, ke hamalan 1, 2 dst 
    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }

    renderPagination() {
        let item = []
        console.log(this.state.TotalPage)
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }



    render() {
        const { List } = this.state
        return (
            <div class="container">
                {/* {JSON.stringify(this.state.Model)} */}
                {/* {JSON.stringify(this.state.Model2)} */}
                <div >
                    {/* {JSON.stringify(this.state.tanggal)} */}

                    <table class="table">
                        <tr>
                            <td>

                                <div class="card-box profile-header">

                                    <div class="profile-view">
                                        <div class="profile-img">
                                            <a href="#"><img class="avatar" src={localStorage.getItem(config.image_path)} alt="" /></a>

                                        </div>
                                    </div>

                                    <div>
                                        <div >
                                            <br />
                                            <div class='text-center'>
                                                <i class="fa fa-star bintang mb-2"></i>
                                                <h3 >Bronze Member</h3>
                                                <h3 class="card-title">Since 2021</h3> <br />
                                            </div>

                                            <div >
                                                <br /><br /><br />
                                                <h4><a href="/pasien" class="name">Pasien</a></h4> <br />
                                                <h4><a href="#/" class="name">Pembelian Obat</a> </h4> <br />
                                                <h4><a href="/rencana_kedatangan" class="name">Rencana Kedatangan</a> </h4> <br />
                                                <h4><a href="#/" class="name">Riwayat Chat Dokter</a> </h4> <br />
                                            </div>



                                        </div>
                                    </div>


                                </div>

                            </td>


                            <td>
                                <div class="content">
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <h1>Rencana Kedatangan</h1> <br />
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card-box">

                                                <div class="form-group row float-right col-6">
                                                    <h4 class="col-form-label col-md-3 mr-0">Urutkan: </h4>

                                                    <select class="form-select btn-outline-primary col-7" onChange={this.filterHandler("urut")} >
                                                        <option value="tanggal_kedatangan" >Tanggal Kedatangan</option>
                                                        <option value="nama_pasien" >Nama Pasien</option>
                                                        <option value="tanggal_dibuat" >Tanggal Dibuat</option>
                                                    </select>

                                                </div>

                                                <div class="input-group col-6 mb-1 float-left">
                                                    <input class="form-control rounded-left" type="text" placeholder="Cari Nama Pasien atau Nama Dokter" onChange={this.filterHandler("search")} />
                                                    <div class="input-group-append" onClick={this.loadList}>
                                                        <button class="btn btn-primary rounded-right" type="button">

                                                            <i class="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <br /> <br /> <br />


                                                <div class="card-header">

                                                    <div class="float-right mr-1">

                                                        <button type="button" class="btn btn-outline-success dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                                                            Show Data
                                                            </button>

                                                        <ul class="dropdown-menu">
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('30')} className="dropdown-item">30</a></li>
                                                        </ul>

                                                    </div>


                                                    <div class="float-right mr-1">

                                                        <button type="button" class="btn btn-outline-warning" onClick={this.sortHandler} >
                                                            Asc / Dsc
                                                            </button>

                                                    </div>



                                                    <button type="button" class="btn btn-danger" onClick={() => this.deleteHandlerr(this.state.ListDelete)}>Batalkan</button>
                                                </div>


                                                <div class="card-body p-0">
                                                    <div class="table-responsive">
                                                        <table class="table mb-0">
                                                            <thead class="d-none">
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th class="float-right"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    List.map(data => {
                                                                        return (
                                                                            <tr >
                                                                                <td class="text-left">
                                                                                    <input class="form-check-input mt-3 ml-1" type="checkbox" onClick={() => this.deleteCheck(data._id)} />
                                                                                </td>

                                                                                <td>
                                                                                    <h2>
                                                                                        {data.nama_pasien}
                                                                                        <span>{data.date} {data.month} {data.year}, {data.medical_facility}</span>
                                                                                        <span>{data.nama_dokter}, - {data.treatment}</span>
                                                                                    </h2>

                                                                                </td>
                                                                                <td class="text-right">
                                                                                    <button class="btn btn-outline-primary take-btn mr-1" onClick={() => this.editHandler(data._id)}>Ubah</button>
                                                                                    <button class="btn btn-outline-danger take-btn" onClick={() => this.deleteHandler(data._id)}>Batalkan</button>
                                                                                </td>
                                                                            </tr>

                                                                        )
                                                                    })
                                                                }

                                                            </tbody>
                                                        </table>
                                                        <div class="float-right mt-2">
                                                            {this.renderPagination()}
                                                        </div>



                                                        <FormInput
                                                            changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            Model={this.state.Model}
                                                            CreateHandler={this.createHandler}
                                                            ShowModal={this.state.showModal}
                                                            // EditHandler={this.editHandler}
                                                            CancelHandler={this.cancelHandler}
                                                            errors={this.state.errors}
                                                            Mode={this.state.Mode}
                                                            ListById={this.state.ListById}
                                                            ListTreatment={this.state.ListTreatment}
                                                        // ListCostumer_Relation={this.state.ListCostumer_Relation}
                                                        />
                                                         <FormInputNew
                                                            changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            Model={this.state.Model}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalJanjiNew={this.state.showModalJanjiNew}
                                                            // EditHandler={this.editHandler}
                                                            CancelHandler={this.cancelHandler}
                                                            errors={this.state.errors}
                                                            Mode={this.state.Mode}
                                                            ListById = {this.state.ListById}
                                                            ListTreatment = {this.state.ListTreatment}
                                                            // ListCostumer_Relation={this.state.ListCostumer_Relation}
                                                        />
                                                        <ModalHapus changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalDel={this.state.showModalDel}
                                                            CancelHandler={this.cancelHandler}
                                                            DeleteHandler2={this.deleteHandler2}
                                                            List={List}
                                                            Model={this.state.Model}
                                                        />
                                                        <ModalHapusList changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalDel2={this.state.showModalDel2}
                                                            CancelHandler={this.cancelHandler}
                                                            List={List}
                                                            Model={this.state.Model}
                                                            ListDelete={this.state.ListDelete}
                                                            DeleteHandlerr2={this.deleteHandlerr2}
                                                        />
                                                        <ModalLoading changeHandler={this.changeHandler}
                                                            showModalLoad={this.state.showModalLoad}
                                                            CancelHandler={this.cancelHandler}
                                                        />
                                                        <ModalBerhasil changeHandler={this.changeHandler}
                                                            showModalBerhasil={this.state.showModalBerhasil}
                                                            CancelHandler={this.cancelHandler}
                                                        />
                                                        <ModalPenuh changeHandler={this.changeHandler}
                                                            showModalPenuh={this.state.showModalPenuh}
                                                            CancelHandler={this.cancelHandler}
                                                            List={this.state.List}
                                                            editHandler={this.editHandler}
                                                            createHandler={this.createHandler}
                                                            Model={this.state.Model}
                                                        />
                                                        <ModalTidakAdaDokter changeHandler={this.changeHandler}
                                                            showModalDokter={this.state.showModalDokter}
                                                            CancelHandler={this.cancelHandler}
                                                            List={this.state.List}
                                                            editHandler={this.editHandler}
                                                            createHandler={this.createHandler}
                                                            Model={this.state.Model}
                                                            Model2={this.state.Model2}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </table>


                </div>
            </div>
        )
    }
}